import {IComponentOptions, ILogService, IWindowService} from "angular";
import {ReferenceData} from "../../shared/reference-data/reference-data.service";
import {Application} from "../../shared/model/Application";
import {ApplicationService} from "../../shared/application/application.service";
import {LoadingService} from "../../shared/loading/loading.service";
import "./dashboard.less";
import {User} from "../../shared/model/User";
import {IModalService} from "angular-ui-bootstrap";

export const LOCAL_STORAGE_KEY = "online-credits-filters";

class DashboardController {
    public debug: boolean = false;
    public processing = false;
    public applications: Application[];
    public draftApplications: Application[];

    private currentUser: User;
    private filters: any;
    private applicationStatuses: any[];
    private archivedStatuses: any[];
    private facultyAdmin: boolean = false;
    private centralAdmissions: boolean = false;

    /* @ngInject */
    constructor(private $log: ILogService,
                private $window: IWindowService,
                private $state: any,
                private $uibModal: IModalService,
                private localStorageService: any,
                private referenceData: ReferenceData,
                private applicationService: ApplicationService,
                private loadingService: LoadingService) {
    }

    public $onInit() {
        this.$log.debug("[DASHBOARD] - Got these applications:", this.applications);

        this.facultyAdmin = this.currentUser.isFacultyAdmin();
        this.centralAdmissions = this.currentUser.isCentralAdmissions;

        this.filters = this.localStorageService.get(LOCAL_STORAGE_KEY);
        if (!this.filters) {
            this.clearFilters();
        }

        this.applicationStatuses = this.referenceData.getAll("StudentCreditApplicationStatus")
            // business decides to remove the Submitted (with Admissions) status as no one is aware of the purpose of this status
            // .filter((status) => this.centralAdmissions || status.id !== "SUBMITTED_WITH_ADMISSIONS");
            .filter(status => status.id !== "SUBMITTED_WITH_ADMISSIONS")
            .filter(status => status.id !== "APPROVED")
            .filter(status => status.id !== "STUDENT_DECLINED")
            .filter(status => status.id !== "STUDENT_ACCEPTED")
            .filter(status => status.id !== "ARCHIVED")
            .filter(status => status.id !== "PENDING_STUDENT_CREDIT_RESPONSE")
            .filter(status => status.id !== "SYSTEM_ACCEPTED")
            .filter(status => status.id !== "SYSTEM_REJECTED");

        this.archivedStatuses = [
            {
                value: false,
                description: "Not archived"
            },
            {
                value: true,
                description: "Archived"
            },
            {
                value: undefined,
                description: "Both"
            }
        ];
    }

    public selectDraftsTab(event: any) {
        this.loadingService.show();
        this.applicationService.getDrafts().then((applications) => {
            this.draftApplications = applications;
        }).finally(() => {
            this.loadingService.hide();
        });
    }

    public selectApplication(event: any) {
        this.$log.debug("selectApplication", event);

        if (event.application.status !== "DRAFTED") {
            this.$state.go("staff.assess", {applicationId: event.applicationId});
        } else {
            this.$state.go("staff.edit", {id: event.applicationId});
        }
    }

    private searchOrFilterChange() {
        this.loadingService.show();
        this.filters.states = this.filters.applicationState ? [this.filters.applicationState] : [];
        this.localStorageService.set(LOCAL_STORAGE_KEY, this.filters);
        this.applicationService.getLightStudentCreditApplications(this.filters).then((applications) => {
            this.applications = applications;
        }).finally(() => {
            this.loadingService.hide();
        });
    }

    private clearFilters() {
        this.filters = {
            states: [],
            nameSearchTerm: "",
            courseSearchTerm: "",
            archived: false
        };
    }

    private createApplication() {
        this.$log.debug("createApplication");
        this.$uibModal.open({
            component: "getStudentModal",
        }).result.then((ids) => {
            this.$log.debug("getStudentModal returned studentId %s applicantid %s ", ids.studentId, ids.applicantId);

            this.$state.go("staff.create" , { id: ids.studentId });
        }, (reason) => {
            this.$log.debug("getStudentModal dismissed: " + reason);
        });
    }

    private exportCSV() {
        this.$log.debug("exportCSV");
        this.$uibModal.open({
            component: "chooseApplicationTimeRangeModal",
            resolve: {
                filters: () => this.filters
            }
        }).result.then((result) => {
            this.$log.debug("chooseApplicationTimeRangeModal returned:", result);
            if (result && result.selectedTimeRange) {
                this.exportAsCsvWithTimeRange(result.selectedTimeRange);
            }
        }, (reason) => {
            this.$log.debug("chooseApplicationTimeRangeModal dismissed: " + reason);
        });
    }

    private exportAsCsv() {
        let url = `/api/student-credit-application/download/csv?nameSearchTerm=${this.filters.nameSearchTerm}`;
        if (this.filters.states.length > 0) {
            url += `&statusFilter=${this.filters.states.join(",")}`;
        }
        if (this.filters.courseSearchTerm !== undefined) {
            url += `&courseSearchTerm=${this.filters.courseSearchTerm}`;
        }
        this.$window.open(url, "_blank");
    }

    private exportAsCsvWithTimeRange(selectedTimeRange: string) {
        let url = `/api/student-credit-application/download/csv?nameSearchTerm=${this.filters.nameSearchTerm}`;
        if (this.filters.states.length > 0) {
            url += `&statusFilter=${this.filters.states.join(",")}`;
        }
        if (this.filters.courseSearchTerm !== undefined) {
            url += `&courseSearchTerm=${this.filters.courseSearchTerm}`;
        }
        if (selectedTimeRange) {
            console.debug("staff exported applications in " + selectedTimeRange);
            url += `&timeRange=${selectedTimeRange}`;
        }
        this.$window.open(url, "_blank");
    }

    private exportOutOfSyncCallistaCsv() {
        let url = `/api/student-credit-application/questionable/2016-01-01`;
        this.$window.open(url, "_blank");
    }
}

export const DashboardComponent: IComponentOptions = {
    bindings: {
        applications: "<",
        currentUser: "<",
        filters: "<",
    },
    controller: DashboardController,
    template: require("./dashboard.html")
};




// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/staff/dashboard/dashboard.component.ts